import { SxProps, Theme } from '@mui/material';

type TStyles = {
  modalContainer: (isMobile: boolean) => SxProps<Theme>;
};

export const styles: TStyles = {
  modalContainer: (isMobile) => (theme: Theme) => ({
    width: 'min(1000px, calc(100% - 32px))',
    maxHeight: 'calc(100vh - 32px)',
    overflowY: isMobile ? 'auto' : 'hidden',
    p: 3,
    bgcolor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    outline: 'none',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 16px)',
      maxHeight: 'calc(100vh - 16px)',
      p: 2,
    },
  }),
};
